import React from "react";
import "../styles/pages.css";

const TermsOfService = () => {
  return (
    <div className="page-container">
      <div className="legal-page">
        <h1 className="legal-title">Terms of Service</h1>
        <div className="legal-content">
          <p className="legal-date">Last Updated: March 24, 2025</p>

          <section className="legal-section">
            <h2>1. Acceptance of Terms</h2>
            <p>
              By using the services provided by PICKTECH ('we', 'us', 'our'),
              you agree to be bound by these Terms of Service. If you do not
              agree with these terms, please discontinue use of our services.
            </p>
          </section>

          <section className="legal-section">
            <h2>2. Service Description</h2>
            <p>
              We provide web development, mobile app development, digital
              marketing, and other related services. Our services may be
              delivered through websites, mobile applications, or other digital
              platforms.
            </p>
          </section>

          <section className="legal-section">
            <h2>3. User Accounts</h2>
            <p>
              Some services may require the creation of a user account. All
              information provided during account creation must be accurate and
              kept up to date. Account security is your responsibility, and any
              suspected unauthorized use should be reported to us immediately.
            </p>
          </section>

          <section className="legal-section">
            <h2>4. Use Restrictions</h2>
            <p>Users must not:</p>
            <ul>
              <li>Use our services for illegal purposes</li>
              <li>
                Infringe on intellectual property rights of our company or third
                parties
              </li>
              <li>Transmit malicious code or infiltrate our systems</li>
              <li>Interfere with the normal operation of our services</li>
              <li>Impersonate others or provide false information</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>5. Intellectual Property</h2>
            <p>
              All intellectual property rights to our website, services, and
              related content belong to us or our licensors. You may not
              reproduce, modify, or distribute these materials without our
              written permission.
            </p>
          </section>

          <section className="legal-section">
            <h2>6. Service Changes and Termination</h2>
            <p>
              We reserve the right to modify, suspend, or discontinue any part
              or all of our services at any time. Prior notice of such changes
              or terminations may not always be provided.
            </p>
          </section>

          <section className="legal-section">
            <h2>7. Limitation of Liability</h2>
            <p>
              To the maximum extent permitted by law, we shall not be liable for
              any direct, indirect, incidental, special, consequential, or
              punitive damages arising from your use of our services.
            </p>
          </section>

          <section className="legal-section">
            <h2>8. Changes to Terms</h2>
            <p>
              We reserve the right to modify these terms at any time. For
              significant changes, we will provide notice on our website or
              through registered email addresses prior to the implementation of
              new terms.
            </p>
          </section>

          <section className="legal-section">
            <h2>9. Governing Law</h2>
            <p>
              These terms shall be governed by and construed in accordance with
              the laws of Australia, and any disputes shall be subject to the
              exclusive jurisdiction of the Australian courts.
            </p>
          </section>

          <section className="legal-section">
            <h2>10. Contact Us</h2>
            <p>
              If you have any questions about these Terms of Service, please
              contact us at:
            </p>
            <p className="contact-info">
              Email: jacob.yu.webdev@gmail.com
              <br />
              Phone: +61 414 989 606
              <br />
              Address: Lidcombe, NSW, Australia
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
